"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RCResourceFormats = exports.RCResource = void 0;
const resource_model_1 = require("./resource.model");
const membership_model_1 = require("./membership.model");
const utils_1 = require("./utils");
/**
 * A team's Resource Center resource.
 *
 * Table: `idea_resourceCentersFolders_resources`.
 *
 * Indexes:
 *    - `resourceCenterFolderId-name-index`; includes: ALL.
 */
class RCResource extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.resourceCenterFolderId = this.clean(x.resourceCenterFolderId, String);
        this.resourceId = this.clean(x.resourceId, String);
        this.folderId = this.clean(x.folderId, String);
        this.name = this.clean(x.name, String);
        this.format = this.clean(x.format, String);
        this.version = this.clean(x.version, a => new Date(a).getTime());
        this.createdAt = this.clean(x.createdAt, d => new Date(d).getTime(), Date.now());
        this.createdBy = new membership_model_1.MembershipSummary(x.createdBy);
        if (x.updatedAt)
            this.updatedAt = this.clean(x.updatedAt, d => new Date(d).getTime());
        if (x.updatedBy)
            this.updatedBy = new membership_model_1.MembershipSummary(x.updatedBy);
    }
    safeLoad(newData, safeData) {
        super.safeLoad(newData, safeData);
        this.resourceCenterFolderId = safeData.resourceCenterFolderId;
        this.resourceId = safeData.resourceId;
        this.folderId = safeData.folderId;
        this.version = safeData.version;
        this.createdAt = safeData.createdAt;
        this.createdBy = safeData.createdBy;
        this.updatedAt = safeData.updatedAt;
        this.updatedBy = safeData.updatedBy;
    }
    validate() {
        const e = super.validate();
        if (this.iE(this.name))
            e.push('name');
        if (!(0, utils_1.loopStringEnumValues)(RCResourceFormats).some(x => x === this.format))
            e.push('format');
        return e;
    }
}
exports.RCResource = RCResource;
/**
 * The allowed formats for a resource.
 */
var RCResourceFormats;
(function (RCResourceFormats) {
    RCResourceFormats["JPG"] = "jpg";
    RCResourceFormats["JPEG"] = "jpeg";
    RCResourceFormats["PNG"] = "png";
    RCResourceFormats["PDF"] = "pdf";
})(RCResourceFormats || (exports.RCResourceFormats = RCResourceFormats = {}));
